import wubwub from './wubwub';

export default wubwub;
